window.addEventListener('load', () => {
  window.googletag = window.googletag || { cmd: [] }
  window.googletag.cmd.push(() => {
    window.googletag.pubads().enableSingleRequest()
    window.googletag.pubads().collapseEmptyDivs()
    window.googletag.enableServices()
  })
})
